/**
 * InfoCard — konsistente Alert/Hint/Warning-Boxen im Valeszka-Style.
 *
 * Ersetzt inkonsistente `bg-blue-50 border-blue-200` / `bg-yellow-50` / `bg-red-50` etc.
 * Variants:
 *   - "info"     (default) — bg-blue-50   border-blue-200   text-blue-900
 *   - "success"            — bg-emerald-50 border-emerald-200 text-emerald-900
 *   - "warning"            — bg-amber-50   border-amber-200   text-amber-900
 *   - "danger"             — bg-red-50    border-red-200    text-red-900
 *   - "neutral"            — bg-[#FAFAFA] border-[#E5E5E5]  text-[#0A0A0A]
 *   - "stx"                — bg-stx-panel border-stx-border text-stx-text
 *
 * Optional icon-prop, title-prop und children als body.
 */
export default function InfoCard({
  variant = "info",
  icon = null,
  title = null,
  children,
  onClose,
  className = "",
  testId,
  size = "md",   // sm | md | lg
}) {
  const VARIANTS = {
    info:    "bg-blue-50    border-blue-200    text-blue-900",
    success: "bg-emerald-50 border-emerald-200 text-emerald-900",
    warning: "bg-amber-50   border-amber-200   text-amber-900",
    danger:  "bg-red-50     border-red-200     text-red-900",
    neutral: "bg-[#FAFAFA]  border-[#E5E5E5]   text-[#0A0A0A]",
    stx:     "bg-stx-panel  border-stx-border  text-stx-text",
  };
  const SIZES = {
    sm: "p-2 text-[11px]",
    md: "p-3 text-xs",
    lg: "p-4 text-sm",
  };
  const cls = VARIANTS[variant] || VARIANTS.info;
  const sz = SIZES[size] || SIZES.md;
  return (
    <div
      data-testid={testId}
      className={`border ${cls} ${sz} ${className}`}
      role={variant === "danger" || variant === "warning" ? "alert" : "note"}
    >
      <div className="flex items-start gap-2">
        {icon && <span className="shrink-0 mt-0.5">{icon}</span>}
        <div className="flex-1 min-w-0">
          {title && <p className="font-bold mb-1 leading-tight">{title}</p>}
          {children && <div className="leading-snug">{children}</div>}
        </div>
        {onClose && (
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            className="shrink-0 opacity-60 hover:opacity-100 -m-1 p-1"
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
}
